import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSettings } from 'services/settings/SettingsContext';
import { AdditionalModule } from './BillingTypes';
import { formatPriceOnUserLocale } from './functions/billingUtils';
import '../../../style/scss/billing.scss';

interface ModuleRowCardProps {
    module: AdditionalModule;
    selected?: boolean;
    onClick?: () => void;
    actionButton?: React.ReactNode;
};

const ModuleRowCard: React.FC<ModuleRowCardProps> = ({ module, selected, onClick, actionButton }) => {
    const { t } = useTranslation();
    const { userLocale } = useSettings();

    // Get the unit price of the module based on its price type
    const modulePrice = module.price_type === 'per_seat'
        ? parseFloat(module.price_per_seat)
        : parseFloat(module.flat_price);

    // Get the unit label of the module based on its price type
    const unitLabel = module.price_type === 'per_seat'
        ? t('billing.module_price.unit_license_label')
        : t('billing.module_price.unit_company_label');

    return (
        <div className={`module-row-card ${selected ? 'selected' : ''} ${onClick ? 'clickable' : ''}`}
             onClick={onClick}>
            {module.image && (
                <div className='module-image'>
                    <img src={module.image} alt={t(module.feature_translation)} />
                </div>
            )}
            <div className='module-info'>
                <h5>{t(module.feature_translation)}</h5>
                {module.description && (
                    <p>{module.description}</p>
                )}
            </div>
            <div className='module-price'>
                <div className='price-label'>
                    <span className='currency-icon'>€ </span>
                    {formatPriceOnUserLocale(modulePrice, userLocale)}
                    <span className='price-period'> {t('billing.module_price.per_month_suffix')}</span>
                </div>
                <div className='price-unit-label'>
                    {unitLabel}
                </div>
            </div>
            {actionButton}
        </div>
    );
};

export default ModuleRowCard;
